//managedesk/src/App/Controllers/Sales/DeliveryNote/index.js
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const token = localStorage.getItem("user");
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

// const create_delivery_note = async (note) => {
//   try {
//     const data = {
//       quote_id: note?.quote_id,
//       items: note?.items,
//     };

//     const response = await axios.post(`${APIURL}/create-delivery-note`, data, config);
//     return response?.data;
//   } catch (error) {
//     return error;
//   }
// };
const create_delivery_note = async (note) => {
  try {
    console.log("Calling create_delivery_note API..."); // ✅
    const response = await axios.post(`${APIURL}/create-delivery-note`, note, config);
    console.log("create_delivery_note success:", response); // ✅
    return response?.data;
  } catch (error) {
    console.error("create_delivery_note error:", error); // ✅
    return error;
  }
};

// const update_delivery_note = async (note) => {
//   try {
//     const data = {
//       id: note?.id,
//       items: note?.items,
//       status: note?.status,
//     };

//     const response = await axios.post(`${APIURL}/update-delivery-note`, data, config);
//     return response?.data;
//   } catch (error) {
//     return error;
//   }
// };
const update_delivery_note = async (note) => {
  try {
    const response = await axios.post(`${APIURL}/update-delivery-note`, note, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_delivery_note = async (note) => {
  try {
    const data = {
      id: note?.id,
    };

    const response = await axios.post(`${APIURL}/delete-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_delivery_note = async (note) => {
  try {
    const data = {
      id: note?.id,
    };

    const response = await axios.post(`${APIURL}/get-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_delivery_notes = async (filter) => {
  try {
    const data = {
      search: filter?.search,
      status: filter?.status,
      customer: filter?.customer,
      date: filter?.date,
      page: filter?.page,
    };

    console.log("📤 Sending POST request to /get-all-delivery-notes with:", data); // ✅

    const response = await axios.post(`${APIURL}/get-all-delivery-notes`, data, config);
    console.log("📥 Received from API:", response.data); // ✅

    return response?.data;
  } catch (error) {
    console.error("🚫 Error calling /get-all-delivery-notes:", error); // ✅
    return error;
  }
};
const get_delivery_note_log = async (filter) => {
  try {
    const data = {
      search: filter?.search,
      sort: filter?.sort,
    };

    const response = await axios.post(`${APIURL}/get-all-delivery-note-logs`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_delivery_note,
  update_delivery_note,
  delete_delivery_note,
  get_delivery_note,
  get_all_delivery_notes,
  get_delivery_note_log,
};
